import {
  baseResource,
} from '@/resource/resource'
import { prefixLanguage } from '@/utils/urls'
import { friendlyUrlGenerator } from '@/utils/friendly'

const CATALOG_PACKS_LIST_URL_PREFIX = prefixLanguage('/ajax-festival-packs/')

export const packsCatalogResource = friendlyUrlGenerator([
  CATALOG_PACKS_LIST_URL_PREFIX, ''
], baseResource)
